module.exports = __webpack_public_path__ + "img/znpp2.43b56cc.png";